import React, { useState } from 'react';
import { Modal, Form, InputNumber } from 'antd';

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: (days: number) => Promise<void>;
}

const SlotExtendModal: React.FC<Props> = ({ open, onClose, onSubmit }) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  return (
    <Modal
      open={open}
      title="연장 기간 입력"
      okText="연장"
      confirmLoading={submitting}
      onCancel={() => { if (!submitting) onClose(); }}
      onOk={async () => {
        if (submitting) return;
        const { days } = await form.validateFields();
        setSubmitting(true);
        try {
          await onSubmit(days);
          onClose();
          form.resetFields();
        } finally {
          setSubmitting(false);
        }
      }}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="days"
          label="연장 일수"
          rules={[{ required: true, type: 'number', min: 1 }]}
        >
          <InputNumber />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SlotExtendModal;
